import { Configuration, RedirectRequest } from "@azure/msal-browser";

export interface ClientConfig {
  environment: string;
  api: string;
  dsn?: string;
}

export const CLIENT_CONFIG = window.orp;

export const msalConfig: Configuration = {
  auth: {
    clientId: "94bc1ae4-f065-43eb-8ea7-4f2385c6d13f",
    authority:
      "https://login.microsoftonline.com/93e6beba-c4aa-4731-af5d-d735b097eadb",
    redirectUri: window.location.origin + "/callback",
    postLogoutRedirectUri: window.location.origin,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: [
    "https://herts365.onmicrosoft.com/orpapi/user_impersonation",
    "offline_access",
  ],
};
